import { CentraStandalonePaymentButton } from "@made-people/grease-centra";

export const MMStandalonePaymentButtons = () => {
  return (
    <>
      <CentraStandalonePaymentButton
        paymentMethod={"paypal-commerce-button-new"}
      />
      <CentraStandalonePaymentButton paymentMethod="spi-new" />
    </>
  );
};
